module.exports = __webpack_public_path__ + "img/31.5a321cbf.jpg";